module.exports = __webpack_public_path__ + "img/title.0ea8ceee.png";